import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import './index.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 70);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);

  const collectionPaths = ['/our-collections','/india-untamed','/eat-pray-love','/asia-wonderlust','/ode-to-the-arts'];

  return (
    <nav className={`custom-navbar ${isScrolled ? 'scrolled' : 'transparent'}`}>
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/"><img src="/lu-logo.png" alt="Logo" className="logo-img" /></Link>
        </div>

        {/* Desktop Menu */}
        <Nav className="desktop-menu d-none d-lg-flex">
          <Link to="/" className={location.pathname === '/' ? 'nav-link active' : 'nav-link'}>Home</Link>
          <Link to="/our-story" className={location.pathname === '/our-story' ? 'nav-link active' : 'nav-link'}>Our Story</Link>
          <Link to="/invest-own" className={location.pathname === '/invest-own' ? 'nav-link active' : 'nav-link'}>Invest &amp; Own</Link>
          <Link to="/lifestyle-investments" className={location.pathname === '/lifestyle-investments' ? 'nav-link active' : 'nav-link'}>Lifestyle Investments</Link>
          <Link to="/about-membership" className={location.pathname === '/about-membership' ? 'nav-link active' : 'nav-link'}>About Membership</Link>
          <Link to="/our-services" className={location.pathname === '/our-services' ? 'nav-link active' : 'nav-link'}>Experience</Link>
          <Link to="/our-collections" className={collectionPaths.includes(location.pathname) ? 'nav-link active' : 'nav-link'}>Our Collections</Link>
        </Nav>

        {/* Connect Button */}
        <div className="connect-btn-wrapper">
          <Link to="/register" className="connect-btn">Connect With Us</Link>
        </div>

        {/* Mobile Toggle */}
        <div className="mobile-menu-toggle d-lg-none" onClick={toggleMenu}>
          <div className="hamburger">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        {/* Mobile Sidebar */}
        <div className={`mobile-sidebar ${isOpen ? 'show' : ''}`}>
          <div className="sidebar-backdrop" onClick={toggleMenu} />
          <div className="sidebar-drawer">

            <div className="sidebar-banner">
              <div className="sidebar-banner-text">
                <p className="sidebar-welcome">Welcome to</p>
                <p className="sidebar-brand">Luxe Unbounded</p>
              </div>
              <button className="sidebar-close" onClick={toggleMenu}>✕</button>
            </div>

            <nav className="sidebar-nav">
              <Link to="/" className={location.pathname === '/' ? 'sidebar-link active' : 'sidebar-link'} onClick={toggleMenu}>Home</Link>
              <Link to="/our-story" className={location.pathname === '/our-story' ? 'sidebar-link active' : 'sidebar-link'} onClick={toggleMenu}>Our Story</Link>
              <Link to="/invest-own" className={location.pathname === '/invest-own' ? 'sidebar-link active' : 'sidebar-link'} onClick={toggleMenu}>Invest &amp; Own</Link>
              <Link to="/lifestyle-investments" className={location.pathname === '/lifestyle-investments' ? 'sidebar-link active' : 'sidebar-link'} onClick={toggleMenu}>Lifestyle Investments</Link>
              <Link to="/about-membership" className={location.pathname === '/about-membership' ? 'sidebar-link active' : 'sidebar-link'} onClick={toggleMenu}>About Membership</Link>
              <Link to="/our-services" className={location.pathname === '/our-services' ? 'sidebar-link active' : 'sidebar-link'} onClick={toggleMenu}>Experience</Link>
              <Link to="/our-collections" className={collectionPaths.includes(location.pathname) ? 'sidebar-link active' : 'sidebar-link'} onClick={toggleMenu}>Our Collections</Link>
            </nav>

            <div className="sidebar-footer">
              <Link to="/register" className="sidebar-cta" onClick={toggleMenu}>Connect With Us</Link>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
